import React from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import NaturalDragAnimation from "natural-drag-animation-rbdnd";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 8px;
  background: white;
  color: rgb(133, 135, 150);
  box-shadow: ${(props) =>
    props.isDragging ? "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)" : "none"};

  transition: box-shadow 0.2s ease-in-out;
`;

const CandidateCardHeaderControls = styled.div`
  display: flex;
`;

const CandidateCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CardTitle = styled.h5`
  line-height: 1.5;
`;

function Candidate({ candidate, index, onOpenModal, previousCandidate, nextCandidate }) {
  return (
    <Draggable draggableId={candidate.id} index={index}>
      {(provided, snapshot) => (
        <NaturalDragAnimation
          style={provided.draggableProps.style}
          snapshot={snapshot}
          animationRotationFade={0.9}
          rotationMultiplier={1}
        >
          {(style) => {
            return (
              <Container
                {...provided.draggableProps}
                ref={provided.innerRef}
                isDragging={snapshot.isDragging}
                style={style}
              >
                <CandidateCardHeader>
                  <CardTitle>{candidate.name}</CardTitle>
                  <CandidateCardHeaderControls>
                    <div
                      className="btn-candidate-card"
                      onClick={onOpenModal(candidate.id, previousCandidate, nextCandidate)}
                    >
                      <i className="fa fa-external-link-alt" aria-hidden="true" candidate={candidate.id}></i>
                    </div>

                    <div className="btn-candidate-card" {...provided.dragHandleProps}>
                      <i className="fa fa-arrows-alt" aria-hidden="true"></i>
                    </div>
                  </CandidateCardHeaderControls>
                </CandidateCardHeader>
                <div>
                  <table className="table table-candidate">
                    <tbody>
                      <tr>
                        <td>Job</td>
                        <td>
                          {candidate.job}, {candidate.location}
                        </td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{candidate.email}</td>
                      </tr>
                      <tr>
                        <td>Phone</td>
                        <td>{candidate.phone}</td>
                      </tr>
                      <tr>
                        <td>Date Applied</td>
                        <td>{candidate.date}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Container>
            );
          }}
        </NaturalDragAnimation>
      )}
    </Draggable>
  );
}

export default Candidate;
